import React from 'react'
import Rollbook from '../../components/grading'
import {Consumer} from '../../context'
import './grading.styl'

export default function GradingPage() {
  return (<Consumer>{context => {
    return (<Rollbook context={context} />)
  }}</Consumer>)
}

